import { render, staticRenderFns } from "./PriceHistory.vue?vue&type=template&id=41827081"
import script from "./PriceHistory.vue?vue&type=script&lang=js"
export * from "./PriceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports